export default __webpack_public_path__ + "static/drip-135c0b8bf327b803603218d2dbd97d9f.gif";